/**
 * CSN Meridian - Main JavaScript
 */

// =============================================================
//  Cookie consent (vanilla-cookieconsent v3, loaded from CDN)
//  wired to Google Consent Mode v2.
//
//  The banner blocks non-essential cookies until the visitor consents.
//  When the "analytics" category is accepted we push a Consent Mode `update`
//  setting analytics_storage to 'granted'; otherwise it stays 'denied'
//  (the default is declared in partials/analytics-head.blade.php).
//  GTM itself only loads when GTM_CONTAINER_ID is set; the gtag bridge below
//  has a no-op dataLayer fallback so this never errors when GTM is off.
// =============================================================
(function () {
    var CC = window.CookieConsent;
    if (!CC || typeof CC.run !== 'function') return; // CDN failed to load — skip silently

    var cfg = window.CSN_COOKIE || {};
    var cookiePolicy = cfg.cookiePolicyUrl || '/politica-cookies';
    var privacyPolicy = cfg.privacyPolicyUrl || '/politica-de-confidentialitate';
    var policyLinks =
        '<a href="' + cookiePolicy + '">Politica de cookie-uri</a> · ' +
        '<a href="' + privacyPolicy + '">Politica de confidențialitate</a>';

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }

    function syncConsentMode() {
        gtag('consent', 'update', {
            analytics_storage: CC.acceptedCategory('analytics') ? 'granted' : 'denied',
        });
    }

    CC.run({
        cookie: { name: 'cc_cookie' },

        guiOptions: {
            consentModal: { layout: 'box wide', position: 'bottom left' },
            preferencesModal: { layout: 'box' },
        },

        categories: {
            necessary: { enabled: true, readOnly: true },
            analytics: { enabled: false },
        },

        onFirstConsent: syncConsentMode,
        onConsent: syncConsentMode,
        onChange: syncConsentMode,

        language: {
            default: 'ro',
            translations: {
                ro: {
                    consentModal: {
                        title: 'Folosim cookie-uri',
                        description:
                            'Folosim cookie-uri strict necesare pentru funcționarea site-ului și, doar cu acordul tău, cookie-uri de statistică (Google Analytics) pentru a înțelege cum este folosit site-ul. Poți accepta sau respinge cookie-urile opționale oricând.',
                        acceptAllBtn: 'Acceptă toate',
                        acceptNecessaryBtn: 'Respinge toate',
                        showPreferencesBtn: 'Setări',
                        footer: policyLinks,
                    },
                    preferencesModal: {
                        title: 'Preferințe cookie-uri',
                        acceptAllBtn: 'Acceptă toate',
                        acceptNecessaryBtn: 'Respinge toate',
                        savePreferencesBtn: 'Salvează preferințele',
                        closeIconLabel: 'Închide',
                        sections: [
                            {
                                title: 'Cum folosim cookie-urile',
                                description:
                                    'Cookie-urile strict necesare sunt mereu active. Cookie-urile de statistică se activează numai cu acordul tău. Îți poți schimba opțiunea oricând din acest panou.',
                            },
                            {
                                title: 'Cookie-uri strict necesare',
                                description:
                                    'Sunt indispensabile pentru funcționarea site-ului (de exemplu reținerea opțiunii tale privind cookie-urile și securitatea formularelor). Nu pot fi dezactivate.',
                                linkedCategory: 'necessary',
                            },
                            {
                                title: 'Cookie-uri de statistică (Google Analytics)',
                                description:
                                    'Ne ajută să înțelegem, în mod anonim și agregat, cum este folosit site-ul (pagini vizitate, sursa traficului), prin Google Analytics 4. Se setează doar dacă le accepți.',
                                linkedCategory: 'analytics',
                            },
                            {
                                title: 'Mai multe informații',
                                description: 'Detalii complete găsești în ' + policyLinks + '.',
                            },
                        ],
                    },
                },
            },
        },
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    const navbar = document.getElementById('mainNavbar');
    if (!navbar) return;

    const isHomePage = document.body.classList.contains('page-home');
    const scrollThreshold = 50;
    let lastScroll = 0;

    function handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll > scrollThreshold) {
            if (!navbar.classList.contains('navbar-scrolled')) {
                navbar.classList.add('navbar-scrolled');

                // Inner pages: add padding to prevent content jump
                if (!isHomePage) {
                    const navHeight = navbar.offsetHeight;
                    document.querySelector('main').style.paddingTop = navHeight + 'px';
                }
            }
        } else {
            if (navbar.classList.contains('navbar-scrolled')) {
                navbar.classList.remove('navbar-scrolled');

                if (!isHomePage) {
                    document.querySelector('main').style.paddingTop = '';
                }
            }
        }

        lastScroll = currentScroll;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    // =============================================
    // Mobile off-canvas menu
    // =============================================
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const mobileMenuBackdrop = document.getElementById('mobileMenuBackdrop');
    let savedScrollY = 0;

    function openMobileMenu() {
        savedScrollY = window.scrollY;
        document.body.style.top = `-${savedScrollY}px`;
        document.body.classList.add('mobile-menu-locked');
        mobileMenu.classList.add('is-open');
        mobileMenuBackdrop.classList.add('is-visible');
    }

    function closeMobileMenu() {
        mobileMenu.classList.remove('is-open');
        mobileMenuBackdrop.classList.remove('is-visible');
        // Close all open drill-down panels
        document.querySelectorAll('.nav-dropdown.is-open').forEach(function(panel) {
            panel.classList.remove('is-open');
        });
        document.body.classList.remove('mobile-menu-locked');
        document.body.style.top = '';
        window.scrollTo(0, savedScrollY);
    }

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', openMobileMenu);
    }
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', closeMobileMenu);
    }
    if (mobileMenuBackdrop) {
        mobileMenuBackdrop.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });

    // Close menu when a nav link is clicked
    if (mobileMenu) {
        mobileMenu.querySelectorAll('.nav-link').forEach(function(link) {
            link.addEventListener('click', closeMobileMenu);
        });
    }

    // Auto-close on resize to desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 992 && mobileMenu && mobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });

    // =============================================
    // Mobile drill-down submenus
    // =============================================
    document.querySelectorAll('.nav-dropdown-toggle').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var dropdown = this.parentElement.querySelector('.nav-dropdown');
            if (dropdown) {
                dropdown.classList.add('is-open');
            }
        });
    });

    document.querySelectorAll('.nav-dropdown__back-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var dropdown = this.closest('.nav-dropdown');
            if (dropdown) {
                dropdown.classList.remove('is-open');
            }
        });
    });

    // News Swiper slider
    var swiperEl = document.querySelector('.newsSwiper');
    if (swiperEl && typeof Swiper !== 'undefined') {
        var prevBtn = document.querySelector('.latest-news__arrow--prev');
        var nextBtn = document.querySelector('.latest-news__arrow--next');

        function updateArrows(swiper) {
            if (!prevBtn || !nextBtn) return;
            prevBtn.classList.toggle('disabled', swiper.isBeginning);
            nextBtn.classList.toggle('disabled', swiper.isEnd);
        }

        var newsSwiper = new Swiper('.newsSwiper', {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 16
                },
                576: {
                    slidesPerView: 1.5,
                    spaceBetween: 16
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            },
            on: {
                init: function() { updateArrows(this); },
                slideChange: function() { updateArrows(this); },
                reachBeginning: function() { updateArrows(this); },
                reachEnd: function() { updateArrows(this); }
            }
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', function() {
                newsSwiper.slidePrev();
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', function() {
                newsSwiper.slideNext();
            });
        }
    }
});
